<template>
  <div>
    <div class="product-wrapper section-gap pb-0 mt-3">
      <div class="container">
        <ul class="nav nav-pills nav-fill mb-4" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-toggle="tab"
              href="#tab-1"
              role="tab"
              aria-controls="active"
              aria-expanded="true"
            >
              {{ $t("Books") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#tab-2"
              role="tab"
              aria-controls="inactive"
            >
              {{ $t("Audio") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#tab-3"
              role="tab"
              aria-controls="inactive"
            >
              {{ $t("Video") }}</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#tab-4"
              role="tab"
              aria-controls="inactive"
            >
              {{ $t("Blogs") }}</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#tab-5"
              role="tab"
              aria-controls="inactive"
            >
              {{ $t("News") }}</a
            >
          </li>
        </ul>
        <div class="tab-content">
          <!-- tab 1 fav books -->
          <div
            v-if="Favorites.MiniBook.length > 0"
            class="tab-pane fade show active"
            id="tab-1"
            role="tabpanel"
          >
            <div class="container-fluid  row">
              <div
                class="col-lg-6 col-md-6 "
                v-for="(content, i) of Favorites.MiniBook"
                :key="i"
              >
                <span
                  @click="UpdateStatus(content.ID, 'libraryID')"
                  class="_addtoFav py-2 px-3 position-absolute "
                >
                  <i
                    class="fa fa-heart text-white fa-2x"
                    v-if="content.IsFavourit"
                  ></i>
                  <i class="far fa-heart text-white fa-2x" v-else></i>
                </span>
                <div class="media mb-4">
                  <img
                    :src="baseURL + content.ImageURL"
                    class="d-flex mr-3"
                    width="200"
                    height="250"
                  />
                  <div class="media-body">
                    <p class="mb-1 ">
                      <a class="text-dark">{{ content.AuthorName }}</a>
                    </p>
                    <p class="mb-1 font-weight-bold">
                      <a class="text-dark">{{ content.Name }}</a>
                    </p>
                    <p class="mb-1 ">
                      <a class="text-dark">{{ content.PublishHouse }}</a>
                    </p>
                    <div class="blog-meta pt-3 ">
                      <a
                        :href="baseURL + content.URL"
                        target="_blank"
                        class="btn btn-primary rounded-pill text-white btn-sm "
                        >{{ $t("ReadNow") }}</a
                      >
                      <!-- <a>
                      <i class="fa fa-calendar-o mr-2 text-muted"></i>
                      <span class="text-muted font-sm">{{ content.date }}</span>
                    </a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- tab 1 else -->
          <div
            v-else
            class="tab-pane fade show active mb-3"
            id="tab-1"
            role="tabpanel"
          >
            <NoDataAva headerTitle="Ops" headerSubTitle="showNoDataAvailable">
            </NoDataAva>
          </div>

          <!-- tab 2 fav audio -->
          <div
            v-if="Favorites.MiniAudio.length > 0"
            class="tab-pane fade"
            id="tab-2"
            role="tabpanel"
          >
            <div class="container-fluid  row">
              <div
                class="col-lg-6 col-md-6 "
                v-for="(content, i) of Favorites.MiniAudio"
                :key="i"
              >
                <span
                  @click="UpdateStatus(content.ID, 'libraryID')"
                  class="_addtoFav py-2 px-3 position-absolute "
                >
                  <i
                    class="fa fa-heart text-white fa-2x"
                    v-if="content.IsFavourit"
                  ></i>
                  <i class="far fa-heart text-white fa-2x" v-else></i>
                </span>
                <div class="media mb-4">
                  <img
                    :src="baseURL + content.ImageURL"
                    class="d-flex mr-3"
                    width="200"
                    height="250"
                  />
                  <div class="media-body">
                    <p class="mb-1 ">
                      <a class="text-dark">{{ content.AuthorName }}</a>
                    </p>
                    <p class="mb-1 font-weight-bold">
                      <a class="text-dark">{{ content.Name }}</a>
                    </p>
                    <p class="mb-1 ">
                      <a class="text-dark">{{ content.PublishHouse }}</a>
                    </p>
                    <div class="blog-meta pt-3 ">
                      <a
                        :href="baseURL + content.URL"
                        target="_blank"
                        class="btn btn-primary rounded-pill text-white btn-sm "
                        >{{ $t("ReadNow") }}</a
                      >
                      <!-- <a>
                      <i class="fa fa-calendar-o mr-2 text-muted"></i>
                      <span class="text-muted font-sm">{{ content.date }}</span>
                    </a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- tab 2 else -->
          <div v-else class="tab-pane fade  mb-3" id="tab-2" role="tabpanel">
            <NoDataAva headerTitle="Ops" headerSubTitle="showNoDataAvailable">
            </NoDataAva>
          </div>

          <!-- tab 3 fav video -->
          <div
            v-if="Favorites.MiniVideo.length > 0"
            class="tab-pane fade"
            id="tab-3"
            role="tabpanel"
          >
            <div class="container-fluid  row">
              <div
                class="col-lg-6 col-md-6 "
                v-for="(content, i) of Favorites.MiniVideo"
                :key="i"
              >
                <span
                  @click="UpdateStatus(content.ID, 'libraryID')"
                  class="_addtoFav py-2 px-3 position-absolute "
                >
                  <i
                    class="fa fa-heart text-white fa-2x"
                    v-if="content.IsFavourit"
                  ></i>
                  <i class="far fa-heart text-white fa-2x" v-else></i>
                </span>
                <div class="media mb-4">
                  <img
                    :src="baseURL + content.ImageURL"
                    class="d-flex mr-3"
                    width="200"
                    height="250"
                  />
                  <div class="media-body">
                    <p class="mb-1 ">
                      <a class="text-dark">{{ content.AuthorName }}</a>
                    </p>
                    <p class="mb-1 font-weight-bold">
                      <a class="text-dark">{{ content.Name }}</a>
                    </p>
                    <p class="mb-1 ">
                      <a class="text-dark">{{ content.PublishHouse }}</a>
                    </p>
                    <div class="blog-meta pt-3 ">
                      <a
                        :href="baseURL + content.URL"
                        target="_blank"
                        class="btn btn-primary rounded-pill text-white btn-sm "
                        >{{ $t("ReadNow") }}</a
                      >
                      <!-- <a>
                      <i class="fa fa-calendar-o mr-2 text-muted"></i>
                      <span class="text-muted font-sm">{{ content.date }}</span>
                    </a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- tab 3 else -->
          <div v-else class="tab-pane fade  mb-3" id="tab-3" role="tabpanel">
            <NoDataAva headerTitle="Ops" headerSubTitle="showNoDataAvailable">
            </NoDataAva>
          </div>

          <!-- tab 4 fav article or blogs -->
          <div
            v-if="Favorites.MiniArticle.length > 0"
            class="tab-pane fade"
            id="tab-4"
            role="tabpanel"
          >
            <div class="container-fluid  row">
              <div
                class="col-lg-6 col-md-6 "
                v-for="(content, i) of Favorites.MiniArticle"
                :key="i"
              >
                <span
                  @click="UpdateStatus(content.ID, 'articleID')"
                  class="_addtoFav py-2 px-3 position-absolute "
                >
                  <i
                    class="fa fa-heart text-white fa-2x"
                    v-if="content.IsFavourit"
                  ></i>
                  <i class="far fa-heart text-white fa-2x" v-else></i>
                </span>
                <div class="media mb-4">
                  <img
                    :src="baseURL + content.ImageURL"
                    class="d-flex mr-3"
                    width="200"
                    height="250"
                  />
                  <div class="media-body">
                    <p class="mb-1 ">
                      <a class="text-dark">{{ content.AuthorName }}</a>
                    </p>
                    <p class="mb-1 font-weight-bold">
                      <a class="text-dark">{{ content.Name }}</a>
                    </p>
                    <p class="mb-1 ">
                      <a class="text-dark">{{ content.PublishHouse }}</a>
                    </p>
                    <div class="blog-meta pt-3 ">
                      <a
                        :href="baseURL + content.ArticleFileURL"
                        target="_blank"
                        class="btn btn-primary rounded-pill text-white btn-sm "
                        >{{ $t("ReadNow") }}</a
                      >
                      <!-- <a>
                      <i class="fa fa-calendar-o mr-2 text-muted"></i>
                      <span class="text-muted font-sm">{{ content.date }}</span>
                    </a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- tab 4 else -->
          <div v-else class="tab-pane fade mb-3" id="tab-4" role="tabpanel">
            <NoDataAva headerTitle="Ops" headerSubTitle="showNoDataAvailable">
            </NoDataAva>
          </div>

          <!-- tab 5 fav news -->
          <div
            v-if="Favorites.MiniNews.length > 0"
            class="tab-pane fade"
            id="tab-5"
            role="tabpanel"
          >
            <div class="container-fluid  row">
              <div
                class="col-lg-6 col-md-6 "
                v-for="(content, i) of Favorites.MiniNews"
                :key="i"
              >
                <span
                  @click="UpdateStatus(content.ID, 'articleID')"
                  class="_addtoFav py-2 px-3 position-absolute "
                >
                  <i
                    class="fa fa-heart text-white fa-2x"
                    v-if="content.IsFavourit"
                  ></i>
                  <i class="far fa-heart text-white fa-2x" v-else></i>
                </span>
                <div class="media mb-4">
                  <img
                    :src="baseURL + content.ImageURL"
                    class="d-flex mr-3"
                    width="200"
                    height="250"
                  />
                  <div class="media-body">
                    <p class="mb-1 ">
                      <a class="text-dark">{{ content.AuthorName }}</a>
                    </p>
                    <p class="mb-1 font-weight-bold">
                      <a class="text-dark">{{ content.Name }}</a>
                    </p>
                    <p class="mb-1 ">
                      <a class="text-dark">{{ content.PublishHouse }}</a>
                    </p>
                    <div class="blog-meta pt-3 ">
                      <a
                        :href="baseURL + content.ArticleFileURL"
                        target="_blank"
                        class="btn btn-primary rounded-pill text-white btn-sm "
                        >{{ $t("ReadNow") }}</a
                      >
                      <!-- <a>
                      <i class="fa fa-calendar-o mr-2 text-muted"></i>
                      <span class="text-muted font-sm">{{ content.date }}</span>
                    </a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- tab 2 else -->
          <div v-else class="tab-pane fade mb-3" id="tab-5" role="tabpanel">
            <NoDataAva headerTitle="Ops" headerSubTitle="showNoDataAvailable">
            </NoDataAva>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-6 mx-auto">
      <button
        @click="back"
        type="border"
        class=" btn btn-primary rounded-pill text-white btn-lg rounded-pill"
      >
        {{ $t("back") }}
      </button>
    </div>
  </div>
</template>
<script>
import { domain } from "@/globalComponents.js";

export default {
  data() {
    return {
      Favorites: {},
      baseURL: domain,
    };
  },

  methods: {
    back() {
      this.$router.go(-1);
    },
    UpdateStatus(ID, string) {
      if (this.$store.state.auth.isUserLoggedIn()) {
        let model = {};
        model[string] = ID;
        this.$store
          .dispatch("DataList/ToggleUserFavorite", model)
          .then((response) => {
            if (response.data.status == "ok") {
              debugger;
              // this.Favorites = response.data.data;
              this.search();
            }
          })
          .catch(() => {});
        return false;
      } else {
        this.$toasted.show(this.$t("PleaseLoginFirst"), {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
        });
        return true;
      }
    },
    search() {
      debugger;
      this.$store
        .dispatch("DataList/UserFavorites")
        .then((response) => {
          if (response.status == 200) {
            debugger;
            this.Favorites = response.data.data;
          }
        })
        .catch(() => {});
    },
  },
  created() {
    this.search();
  },
};
</script>
